export default __webpack_public_path__ + "static/media/Electric Hook Up - Grey.63b15169.svg";